import 'svelte/internal/disclose-version';

EmptyState[$.FILENAME] = 'src/components/EmptyState.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations($.from_html(`<p class="svelte-1uba7bi"> </p>`), EmptyState[$.FILENAME], [[8, 15]]);
var root_1 = $.add_locations($.from_html(`<a class="cta svelte-1uba7bi"> </a>`), EmptyState[$.FILENAME], [[10, 4]]);
var root_2 = $.add_locations($.from_html(`<div class="empty svelte-1uba7bi"><div class="icon svelte-1uba7bi" aria-hidden="true"> </div> <h3 class="svelte-1uba7bi"> </h3> <!> <!></div>`), EmptyState[$.FILENAME], [[5, 0, [[6, 2], [7, 2]]]]);

const $$css = {
	hash: 'svelte-1uba7bi',
	code: '\n  .empty.svelte-1uba7bi {\n    text-align: center;\n    padding: 56px 24px;\n    background: var(--card);\n    border: 1px dashed var(--line-strong);\n    border-radius: var(--radius-lg);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n  .icon.svelte-1uba7bi { font-size: 2.6rem; }\n  h3.svelte-1uba7bi { font-size: 1.2rem; }\n  p.svelte-1uba7bi { margin: 0; color: var(--ink-soft); max-width: 40ch; line-height: 1.55; }\n  .cta.svelte-1uba7bi {\n    margin-top: 10px;\n    background: var(--accent);\n    color: #fff;\n    font-weight: 600;\n    font-size: 0.9rem;\n    padding: 10px 20px;\n    border-radius: var(--radius-pill);\n  }\n  .cta.svelte-1uba7bi:hover { background: var(--accent-dark); }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function EmptyState($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, EmptyState);
	$.append_styles($$anchor, $$css);

	let icon = $.prop($$props, 'icon', 3, "🍜"),
		title = $.prop($$props, 'title', 3, "Nothing here yet"),
		message = $.prop($$props, 'message', 3, ""),
		action = $.prop($$props, 'action', 3, null);

	var $$exports = { ...$.legacy_api() };
	var div = root_2();
	var div_1 = $.child(div);
	var text = $.child(div_1, true);

	$.reset(div_1);

	var h3 = $.sibling(div_1, 2);
	var text_1 = $.child(h3, true);

	$.reset(h3);

	var node = $.sibling(h3, 2);

	{
		var consequent = ($$anchor) => {
			var p = root();
			var text_2 = $.child(p, true);

			$.reset(p);
			$.template_effect(() => $.set_text(text_2, message()));
			$.append($$anchor, p);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (message()) $$render(consequent);
			}),
			'if',
			EmptyState,
			8,
			2
		);
	}

	var node_1 = $.sibling(node, 2);

	{
		var consequent_1 = ($$anchor) => {
			var a = root_1();
			var text_3 = $.child(a, true);

			$.reset(a);

			$.template_effect(() => {
				$.set_attribute(a, 'href', action().href);
				$.set_text(text_3, action().label);
			});

			$.append($$anchor, a);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if (action()) $$render(consequent_1);
			}),
			'if',
			EmptyState,
			9,
			2
		);
	}

	$.reset(div);

	$.template_effect(() => {
		$.set_text(text, icon());
		$.set_text(text_1, title());
	});

	$.append($$anchor, div);

	return $.pop($$exports);
}